import React from "react";
import { Menu, Icon } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "../../util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";
import { roles } from "../../misc/enumerations";

const SubMenu = Menu.SubMenu;

const AdminMenu = ({ getNavStyleSubMenuClass, defaultOpenKeys, selectedKeys, themeType }) => {
  return <Menu
    defaultOpenKeys={[defaultOpenKeys]}
    selectedKeys={[selectedKeys]}
    theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
    mode="inline">


    <Menu.Item key="dashboard/index">
      <Link to="/dashboard/index">
        <i className="icon icon-dasbhoard" />
        <span>Dashboard</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="contentKeys">
      <Link to="/content-keys">
        <Icon type="database" />
        <span>Manage Content Keys</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="menu/index">
      <Link to="/menu/index">
        <i className="icon icon-product-list" />
        <span>Manage Menu</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="item/index">
      <Link to="/item/index">
        <i className="icon icon-product-list" />
        <span>Manage Item</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="categories/index">
      <Link to="/categories/index">
        <i className="icon icon-ckeditor" />
        <span>Manage Categories</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="setting/index">
      <Link to="/setting/index">
        <i className="icon icon-setting" />
        <span>Setting</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="url-redirects">
      <Link to="/url-redirects">
        <i className="icon icon-setting" />
        <span>URL Redirects</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="blogs/index">
      <Link to="/blogs/index">
        <i className="icon icon-ckeditor" />
        <span>Manage Blogs</span>
      </Link>
    </Menu.Item>

    <Menu.Item key="images/index">
      <Link to="/images/index">
        <i className="icon icon-image" />
        <span>Manage Images</span>
      </Link>
    </Menu.Item>

     <Menu.Item key="poups/index">
      <Link to="/popups/index">
        <i className="icon icon-image" />
        <span>Manage Popups</span>
      </Link>
    </Menu.Item>
    <Menu.Item key="ads/index">
      <Link to="/ads/index">
        <i className="icon icon-image" />
        <span>Manage Ads</span>
      </Link>
    </Menu.Item>
    <Menu.Item key="users/index">
      <Link to="/users/index">
        <i className="icon icon-profile" />
        <span>Manage Users</span>
      </Link>
    </Menu.Item>
    <Menu.Item key="schools/index">
      <Link to="/schools/index">
        <i className="icon icon-profile" />
        <span>Manage Schools</span>
      </Link>
    </Menu.Item>
    <Menu.Item key="downloadSettings/index">
      <Link to="/downloadSettings/index">
        <i className="icon icon-upload" />
        <span>Manage Downloads</span>
      </Link>
    </Menu.Item>
    <Menu.Item key="zipfiles/index">
      <Link to="/zipfiles/index">
        <i className="icon icon-folder" />
        <span>Manage Zip Files</span>
      </Link>
    </Menu.Item>
    {/* <SubMenu key="" className={getNavStyleSubMenuClass()}
      title={<span> <i className="icon icon-setting" />
        <span>Settings</span></span>}>

      <Menu.Item key="categories/index">
        <Link to="/categories/index">
          <span>Manage Categories</span>
        </Link>
      </Menu.Item>
    </SubMenu> */}

  </Menu>

}

const SeoUserMenu = ({ getNavStyleSubMenuClass, defaultOpenKeys, selectedKeys, themeType }) => {
  return <Menu
    defaultOpenKeys={[defaultOpenKeys]}
    selectedKeys={[selectedKeys]}
    theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
    mode="inline">

    <Menu.Item key="users/index">
      <Link to="/users/index">
        <i className="icon icon-profile" />
        <span>Manage Users</span>
      </Link>
    </Menu.Item>

    <SubMenu key="" className={getNavStyleSubMenuClass()}
      title={<span> <i className="icon icon-setting" />
        <span>Settings</span></span>}>

      <Menu.Item key="categories/index">
        <Link to="/categories/index">
          <span>Manage Categories</span>
        </Link>
      </Menu.Item>

    </SubMenu>
    <Menu.Item key="metaData">
      <Link to="/metaData">
        <Icon type="database" />
        <span>Meta Data</span>
      </Link>
    </Menu.Item>
  </Menu>

}

const SchoolAdminMenu = ({ getNavStyleSubMenuClass, defaultOpenKeys, selectedKeys, themeType }) => {
  return (
    <Menu
      defaultOpenKeys={[defaultOpenKeys]}
      selectedKeys={[selectedKeys]}
      theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
      mode="inline"
    >
      <Menu.Item key="schooladmindashboard/index">
        <Link to="/schooladmindashboard/index">
          <i className="icon icon-dasbhoard" />
          <span>Dashboard</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="staff/index">
        <Link to="/staff/index">
          <i className="icon icon-profile" />
          <span>Manage Staff</span>
        </Link>
      </Menu.Item>
    </Menu>
    
  );
};

const getUserRole = () => {
  try {
    return localStorage.getItem('role'); // "Admin", "Seo", "SchoolAdmin"
  } catch (e) {
    console.log(e);
    return null;
  }
};

const SidebarContent = () => {

  let { navStyle, themeType, pathname } = useSelector(({ settings }) => settings);

  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];
  const options = {
    themeType: themeType,
    selectedKeys: selectedKeys,
    defaultOpenKeys: defaultOpenKeys,
    getNavStyleSubMenuClass: () => getNavStyleSubMenuClass(navStyle)
  }
   const role = getUserRole();
  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile />
          <AppsNavigation />
        </div>
        {/* <CustomScrollbars className="gx-layout-sider-scrollbar">
          {isSEO() === roles.Seo ? <SeoUserMenu {...options} /> : <AdminMenu {...options} />}
        </CustomScrollbars> */}
         <CustomScrollbars className="gx-layout-sider-scrollbar">
          {role === roles.Seo && <SeoUserMenu {...options} />}
          {role === roles.Admin && <AdminMenu {...options} />}
          {role === roles.SchoolAdmin && <SchoolAdminMenu {...options} />}
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;
